import type { TranslateDictionary } from './en.js';

export const Ro: TranslateDictionary = {
  'Start airplay': 'Pornește AirPlay',
  'Stop airplay': 'Oprește AirPlay',
  Audio: 'Audio',
  Captions: 'Subtitrări',
  'Enable captions': 'Activare subtitrare',
  'Disable captions': 'Dezactivare subtitrare',
  'Start casting': 'Pornește transmiterea',
  'Stop casting': 'Oprește transmiterea',
  'Enter fullscreen mode': 'Activare întregul ecran',
  'Exit fullscreen mode': 'Dezactivare întregul ecran',
  Mute: 'Mut',
  Unmute: 'Sunet',
  'Enter picture in picture mode': 'Activează modul imagine-în-imagine',
  'Exit picture in picture mode': 'Dezactivează modul imagine-în-imagine',
  Play: 'Redare',
  Pause: 'Pauză',
  'Playback rate': 'Viteză de redare',
  'Playback rate {playbackRate}': 'Viteză de redare {playbackRate}',
  Quality: 'Calitate',
  'Seek backward': 'Înapoi',
  'Seek forward': 'Înainte',
  Settings: 'Setări',
  Auto: 'Auto',
  'audio player': 'player audio',
  'video player': 'player video',
  volume: 'Volum',
  seek: 'Căutare',
  'closed captions': 'Subtitrări',
  'current playback rate': 'viteza curentă de redare',
  'playback time': 'timp de redare',
  'media loading': 'încărcare media',
  settings: 'Setări',
  'audio tracks': 'piste audio',
  quality: 'Calitate',
  play: 'redare',
  pause: 'pauză',
  mute: 'mut',
  unmute: 'sunet',
  'chapter: {chapterName}': 'capitol: {chapterName}',
  live: 'live',
  Off: 'Oprit',
  'start airplay': 'pornește AirPlay',
  'stop airplay': 'oprește AirPlay',
  'start casting': 'pornește transmiterea',
  'stop casting': 'oprește transmiterea',
  'enter fullscreen mode': 'activare întregul ecran',
  'exit fullscreen mode': 'dezactivare întregul ecran',
  'enter picture in picture mode': 'activează modul imagine-în-imagine',
  'exit picture in picture mode': 'dezactivează modul imagine-în-imagine',
  'seek to live': 'mergi la live',
  'playing live': 'redare live',
  'seek back {seekOffset} seconds': 'înapoi {seekOffset} secunde',
  'seek forward {seekOffset} seconds': 'înainte {seekOffset} secunde',
  'Network Error': 'Eroare de rețea',
  'Decode Error': 'Eroare de decodare',
  'Source Not Supported': 'Sursă nesuportată',
  'Encryption Error': 'Eroare de criptare',
  'A network error caused the media download to fail.':
    'O eroare de rețea a cauzat eșecul descărcării media.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'O eroare media a cauzat întreruperea redării. Media ar putea fi coruptă sau browserul dvs. nu suportă acest format.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'A apărut o eroare nesuportată. Serverul sau rețeaua au eșuat, sau browserul dvs. nu suportă acest format.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Media este criptată și nu există chei pentru a o decripta.',
};
